import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
export function UrgencySection() {
  return <section className="py-20 px-4 bg-brown text-cream text-center" data-id="element-200">
      <div className="max-w-3xl mx-auto" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-202">
          <div className="flex justify-center mb-6" data-id="element-203">
            <Clock className="w-12 h-12 text-gold-end" data-id="element-204" />
          </div>

          <div className="space-y-2 text-lg md:text-xl font-medium mb-16 text-cream-alt/90" data-id="element-205">
            <p data-id="element-206">Este programa está disponible online por tiempo limitado.</p>
            <p data-id="element-207">Aprovecha el acceso ahora y comienza hoy mismo.</p>
          </div>

          <div className="space-y-6 mb-12" data-id="element-208">
            <p className="text-2xl md:text-3xl font-playfair italic text-gold-start" data-id="element-209">
              Tu mente puede ser tu mayor fuente de estrés…
            </p>
            <p className="text-2xl md:text-3xl font-playfair italic text-gold-start" data-id="element-210">
              O tu mayor fuente de claridad.
            </p>
            <p className="text-xl md:text-2xl font-medium mt-8" data-id="element-211">
              La diferencia está en aprender a manejarla.
            </p>
          </div>

          <PriceBlock compact darkMode data-id="element-212" />
          <CtaButton text="QUIERO CALMAR MI MENTE AHORA" data-id="element-213" />
        </motion.div>
      </div>
    </section>;
}